import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function RedirectIfAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="page-loading">Cargando...</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}
